import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputCheckBoxUI from '../../../widgets/form/InputCheckBoxUI'
import './LoanCreateModal.css'

const ProjectUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onUpdateClick, onCancelUpdate,
  // form fields
  customerId, onCustomerIdChange, customerIdError,setCustomerIdError,customerList,
  projectName, onProjectNameChange, projectNameError, setProjectNameError,
  projectCostF, onProjectCostChange,projectCostError,setProjectCostChangeError,
  expectedMarginPercent,onExpectedMarginPercentChange,expectedMarginPercentError,setExpectedMarginPercentageError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update project'
    buttonLabel='Update project'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelUpdate}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onUpdateClick}
    busy={submitted}
  >
    <div className='g_flex_h g_flex_top c_ln_crt'>
      <div className='col'>
        {/* <InputSelectSF type='select' name='customerId' required={true} label='Customer'
          value={customerId} optionList={customerList}
          onChange={onCustomerIdChange} error={customerIdError} setError={setCustomerIdError}
        /> */}
        <InputTextSF type='text' name='projectName' required={true} maxLength={40}
          label='Project name' autoFocus={true}
          value={projectName} onChange={onProjectNameChange}
          error={projectNameError}
          setError={setProjectNameError}
        />
        <InputTextSF type='text' name='projectCost' label='Project cost'
          value={projectCostF} 
          onChange={onProjectCostChange} error={projectCostError}
          setError={setProjectCostChangeError}
        />
        <InputTextSF type='text' name='expectedMarginPercent' label='Expected margin percent'
          value={expectedMarginPercent} 
          onChange={onExpectedMarginPercentChange} error={expectedMarginPercentError}
          setError={setExpectedMarginPercentageError}
        />
      </div>
    </div>
  </ModalFormUI>

export default ProjectUpdateModalUI
